module.exports = __webpack_public_path__ + "static/media/Ads Logo_LightMode.47df374a.svg";